@if (form) {
  <mat-form-field 
      appearance="outline" 
      [formGroup]="form" 
      color="primary"
      subscriptSizing="dynamic" 
      [class]="`${this.field.className} autocomplete`"
  >
  <mat-label>{{field.label}}</mat-label>
  <input #input matInput type="text" [formControlName]="field.key" [matAutocomplete]="auto"
      [readonly]="field.readonly" [id]="field.key" (input)="this.onInputChange()" (focus)="this.onFocus()" (blur)="this.onBlur($event)"
      autocomplete="new-password" [errorStateMatcher]="this.errorStateMatcher()"/>
  <mat-autocomplete #autocomplete class="autocomplete" #auto="matAutocomplete" [displayWith]="displayWith" autoActiveFirstOption
    (opened)="this.handleOnAutocompleteOpen()" panelWidth="fit-content" (optionSelected)="onOptionSelected($event)">
    @if((filteredOptions | async)?.length === 0 && (this.autocompleteService.isAwaitingDebounce$ | async)) {
        <mat-option class="min-w-72" disabled>
            <div class="flex justify-center items-center h-full">
                <mat-spinner [diameter]="20" ></mat-spinner>
            </div>
        </mat-option>
    } @else if ((filteredOptions | async)?.length === 0) {
        <mat-option class="min-w-72" disabled>
            <span i18n>No match found</span>
        </mat-option>
    } @else {
        @for (option of filteredOptions | async; track option) {
            <mat-option class="optionClassName" [class]="field.labelClassName" [value]="option" (mousedown)="$event.preventDefault()">
                <div class="optionInfoWrapper flex items-center">
                    <div [appHighlightText]="option.viewValue" [highlightTerm]="getHighlightTerm()">{{option.viewValue}}</div>
                    <div class="ml-auto iconsWrapper">
                        @for(icon of this.getOptionIcons(option.icon); track icon) {
                            <lib-app-icon [class]="option.iconOptions?.className" [icon]="icon"
                            [size]="option.iconOptions?.size || '40x40'" />
                        }
                    </div>
                </div>
            </mat-option>
        }
        @if (this.autocompleteService.isPaginating$ | async) {
            <mat-option class="min-w-72" disabled (mousedown)="$event.preventDefault()">
                <div class="flex justify-center items-center h-full">
                    <mat-spinner [diameter]="20"></mat-spinner>
                </div>
            </mat-option>
        }
        <div
            calLazyLoad
            (lazyLoad)="loadMoreItems()"
            class="h-[2px]"
        ></div>
    }
  </mat-autocomplete>
   @if(getCommonErrors()) {
        <mat-error>{{ getCommonErrors() }}</mat-error>
    }
    @if(this.hint()) {
        <mat-hint>{{ this.hint() }}</mat-hint>
    }
  @if(getSuffixIcon()) {
      <lib-app-icon [icon]="getSuffixIcon()" matSuffix size="48x48" className="p-[12px]" />
  }
</mat-form-field>
} @else {
  <mat-form-field 
      appearance="outline" 
      color="primary" 
      class="autocomplete" 
      subscriptSizing="dynamic" 
      [class]="field.className"
  >
  <mat-label>{{field.label}}</mat-label>
  <input #input matInput type="text" [id]="field.key" [name]="field.key" [matAutocomplete]="auto"
      [value]="field.value" (input)="this.onInputChange()" (focus)="this.onInputChange()" [errorStateMatcher]="this.errorStateMatcher()"/>
  <mat-autocomplete class="autocomplete" #auto="matAutocomplete" [displayWith]="displayWith" autoActiveFirstOption
    (opened)="this.handleOnAutocompleteOpen()">
        @for (option of filteredOptions | async; track option) {
            <mat-option [value]="option" (mousedown)="$event.preventDefault()">{{option.viewValue}}</mat-option>
        }
        
  </mat-autocomplete>
    @if(getCommonErrors()) {
        <mat-error>{{ getCommonErrors() }}</mat-error>
    }
    @if(this.hint()) {
        <mat-hint>{{ this.hint() }}</mat-hint>
    }
  @if(field.icon) {
      <lib-app-icon [icon]="field.icon" matSuffix size="48x48" className="p-[12px]" />
  }
  </mat-form-field>
}